/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IHeaderViewProps } from './citta-commercial-header';

const headerView: React.FC<IHeaderViewProps> = props => {
    const {
        HeaderTag,
        menuBar,
        MobileMenuContainer,
        MobileMenuBodyContainer,
        logo
    } = props;
    return (
        <Module {...HeaderTag}>
            {props.navIcon}
            {_renderReactFragment(menuBar!)}
            {logo}
            <Node {...MobileMenuContainer}>
                <Node {...MobileMenuBodyContainer}>
                    { props.MobileMenuHeader }
                    {_renderReactFragment(menuBar!)}
                    
                </Node>
            </Node>
        </Module>
    );
};

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <React.Fragment>
            {items && items.length
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </React.Fragment>
    );
}

export default headerView;
